import { useEffect } from "react";

/**
 * Registers /service-worker.js (PWA shell) on app boot.
 * Silent on unsupported browsers. firebase-messaging-sw.js is registered
 * separately by the FCM library so we don't touch it here.
 */
export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
    if (window.location.hostname === "localhost") return; // avoid CRA dev cache conflicts
    const onLoad = () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .catch((e) => console.warn("[PWA] SW register failed:", e?.message));
    };
    window.addEventListener("load", onLoad);
    return () => window.removeEventListener("load", onLoad);
  }, []);
  return null;
}
